import script from "./listDashboardPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./listDashboardPopup.vue?vue&type=script&setup=true&lang=js"

import "./listDashboardPopup.vue?vue&type=style&index=0&id=4f29bc46&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f29bc46"]])

export default __exports__